import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import '../SettingsViews/SettingsListView.scss'
import './ReceiptItemToFilingType.scss'
import { CheckboxList } from '../SettingsViews/SettingsComponents/CheckboxList'
import ReceiptItemToFilingTypeOptions from '../SettingsViews/Options/ReceiptItemToFilingTypeOptions'
import { GET_SETTINGS_RECEIPT_ITEM_TYPES } from '../../../requests'
import { useRequestData } from '../../../Utilities/hooks'
import { ContextButton } from '@tecuity/granite-ui'
import Revert from '@tecuity/sos-icons/react/revert'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import * as api from '../../../requests'
import { SET_SETTINGS_LIST, SET_OPTIONAL_DATA } from '../SettingsReducer'
import { setErrorToast, setSuccessToast } from '../../../actions'
import { Spinner } from '../../Loaders/Loaders'
import { FilingSourceTypeIds} from '../../../Utilities/Utilities'

const ReceiptItemToFilingType = () => {
  const dispatch = useDispatch()
  const { optionalData, settingsList } = useSelector((state) => state.settings, shallowEqual)
  const { sourceType = 0, recordType = 0, filingType = 0, recordSubType = 0, miscellaneousModule = 0, orderSourceType = 0 } = optionalData
  const receiptItemTypes = useRequestData(GET_SETTINGS_RECEIPT_ITEM_TYPES, [], [])
  const [checkedTypes, setCheckedTypes] = useState(settingsList.ReceiptItemTypeIds || [])
  const [isDirty, setIsDirty] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setCheckedTypes(settingsList.ReceiptItemTypeIds)
    setIsDirty(false)
  }, [settingsList.ReceiptItemTypeIds])

  useEffect(() => {
    return () => {
      dispatch({ type: SET_SETTINGS_LIST, settingsList: [] })
    }
  }, [])

  const clickRevert = () => {
    setLoading(true)    
    if(sourceType === FilingSourceTypeIds.Miscellaneous.toString()){
      api.GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_MISCELLANEOUS(
        sourceType,
        miscellaneousModule,
        filingType,        
        (res) => {
          dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
          dispatch({ type: SET_OPTIONAL_DATA, optionalData: { sourceType, recordType, filingType, recordSubType, miscellaneousModule, orderSourceType } })
          setLoading(false)
        },
        (err) => {
          console.error('retrieving', err)
          setLoading(false)
        }
      )
    }
    else{
      api.GET_SETTINGS_RECEIPT_ITEM_TYPE_XREF_BY_TYPES_SUB_TYPE(
        sourceType,
        recordType,
        filingType,
        recordSubType,
        (res) => {
          dispatch({ type: SET_SETTINGS_LIST, settingsList: res })
          dispatch({ type: SET_OPTIONAL_DATA, optionalData: { sourceType, recordType, filingType, recordSubType, miscellaneousModule, orderSourceType } })
          setLoading(false)
        },
        (err) => {
          console.error('retrieving', err)
          setLoading(false)
        }
      )
    }    
  }

  const clickSave = () => {    
    if (settingsList.SourceTypeId) {            
      if(sourceType === FilingSourceTypeIds.Miscellaneous.toString() && miscellaneousModule === 0){
        dispatch(setErrorToast(`Miscellaneous Module is required`))
      }
      else{  
        setLoading(true)    
        api.SAVE_SETTINGS_RECEIPT_ITEM_TYPE_XREF(
          { ...settingsList, ReceiptItemTypeIds: [...checkedTypes] },
          (res) => {
            clickRevert()
            dispatch(setSuccessToast('Successfully saved XRef'))
          },
          (err) => {
            console.error(err)
            dispatch(setErrorToast('Failed to save XRef'))
            setLoading(false)
          }
        )
      }
    } else {
      dispatch(setErrorToast(`Source Type is required`))
    }    
  }

  return (
    <div className="settings-list-view">
      <h2>Receipt Item Types To Filing Types</h2>
      <ReceiptItemToFilingTypeOptions />
      <div className="content-column-direction">
        <CheckboxList
          allowShowOnlyChecked
          checkListOnly
          label="Receipt Item Types"
          items={receiptItemTypes.map((type) => {
            return {
              label: `${type.Name}`, // - ${type.IsActive ? 'Active' : 'Inactive'}`,
              id: type.Id,
            }
          })}
          checkedList={checkedTypes || []}
          setActiveChanges={(newTypes) => {
            setCheckedTypes(newTypes)
            setIsDirty(true)
          }}
        />
        <div className="button-wrapper">
          {loading && (
            <div className="loading-type">
              <Spinner size="small" themeColor="dark-neutral" />
            </div>
          )}
          <ContextButton
            variant="danger"
            disabled={!isDirty}
            leftIcon={
              <div className="checkmark-wrapper left">
                <Revert />
              </div>
            }
            onClick={clickRevert}
          >
            Revert
          </ContextButton>
          <ContextButton
            variant="primary"
            disabled={!isDirty}
            rightIcon={
              <div className="checkmark-wrapper right">
                <RightArrow />
              </div>
            }
            onClick={clickSave}
          >
            Save
          </ContextButton>
        </div>
      </div>
    </div>
  )
}

export default ReceiptItemToFilingType
